import React from 'react';

const LazyImage = ({ src, ...rest }) => (
   <img src={src} alt="" {...rest} loading="lazy" />
);

export default LazyImage;